export class BootstrapClasses {
  public static weights: string[] = ["bold", "bolder", "normal", "light", "lighter"];
  public static styles: string[] = ["italic"];
  public static texts: string[] = ["start", "center", "end", "justify"];
}
